/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VisualizzazioneTipoPratica } from './visualizzazione-tipo-pratica';
import { TipoPraticaStato } from './tipo-pratica-stato';


export interface TipoPraticaOperatoreStatoDTO { 
    titolo?: string;
    stato?: TipoPraticaStato;
    visualizzazione?: VisualizzazioneTipoPratica;
}



